<template>
  <div>
    <h2 class="col-xs-offset-1 col-sm-offset-2">{{ section }}</h2>
    <!-- <FadeLeft appear :key="item.id" :duration="500" :delay="1000 + (item.id * 100)"> -->
    <ul class="col-xs-offset-2 col-sm-offset-3 projectMenu">
      <li
        v-for="item in $store.getters.projectsByType(projects)"
        :key="item.id"
        class="listLink"
        v-on:mouseover="changeActive(item)"
      >
        <router-link
          :to="createRouterLink(item)"
          class="projectLink"
          :class="{ isActive: activeProject == item.id }"
          :target="item.Target"
        >
          <span class="projectSpan">
            <h3 class="projectTitle">{{ item.Title }}</h3>
          </span>
          <p class="projectDescription">{{ item.Short }}</p>
        </router-link>
      </li>
    </ul>
  </div>
  <!-- </FadeLeft> -->
</template>
<script>
export default {
  name: "ProjectList",
  props: {
    section: String,
    projects: String
  },
  computed: {
    activeProject: function() {
      return this.$store.state.selectedProjectId;
    }
  },
  methods: {
    changeActive: function(item) {
      // this.$emit('hovered', idx);
      this.$store.commit("imageFlip", item);
    },
    createRouterLink: function(item) {
      let str = "/";
      str += item.Title.replace(/[^\w\d]/g, "");
      return str;
    }
  }
};
</script>
<style lang="scss">
// * {
//   border: 1px solid red;
// }

.projectMenu {
  list-style-type: none;
  // margin-left: ($gutter + $content-margins);
  vertical-align: middle;
  // height: 65vh;
  padding: 0;
  .projectLink {
    color: $text-color;
    display: inline-block;
    // opacity: .7;
    transition: color 300ms ease-in-out 0s;
    backface-visibility: hidden;
  }
  .projectTitle {
    color: inherit;
    line-height: normal;
    font-weight: 500;
    font-style: italic;
    font-size: 1.25rem;
    backface-visibility: hidden;
  }
  .projectDescription {
    margin: 0;
    margin-bottom: 2rem;
    font-size: 1.06rem;
  }
  .projectLink:visited {
    color: $text-color;
  }
  .projectLink:hover,
  .projectTitle:hover {
    color: $almost-black;
    text-decoration: none;
    opacity: 1;
  }
}
.projectLink {
  text-decoration: none;
  > .projectSpan {
    position: relative;
  }
}
.projectLink > .projectSpan:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: $dark-grey;
  visibility: hidden;
  transform-origin: left;
  -webkit-transform: scaleX(0);
  transform: scaleX(0);
  -webkit-transition: all 0.3s ease-in-out 0s;
  transition: all 0.3s ease-in-out 0s;
}

.isActive > .projectSpan:before,
.projectLink:hover > .projectSpan:before {
  @include respond-to(sm) {
    visibility: visible;
    transform-origin: left;
    -webkit-transform: scaleX(1);
    transform: scaleX(1);
  }
}

.projectSpan {
  display: inline-block;
}
</style>
